"use strict";
//import smoothscroll from "smoothscroll-polyfill";
import { addEvent } from "./addEvent/addEvent";
import { isMobile } from "./isMobile/isMobile";
import "./colorbox/jquery.colorbox-min.js?";
import "./colorbox/colorbox.scss";
import { mobileMenu } from "./mobileMenu/mobileMenu";
import { mainPageBaner } from "./mainPageBaner/mainPageBaner";
// import { mainPageImportantBoxes } from "./mainPageImportantBoxes/mainPageImportantBoxes";
import { popUp } from "./popUp/popUp";
import { pageBaner } from "./pageBaner/pageBaner";
import { lazyLoadImage } from "./lazyLoading/lazyLoading";
import { addVideoToPage } from "./addVideoToPage/addVideoToPage";
import { ajaxFormClass } from "./form/form";
//import { showMoreInfo } from "./showMoreInfo/showMoreInfo";
import { showHideSearchForm } from "./search/search";
import { accessibilityInit, outlineInit } from './accessibility/accessibility';
import { mainMenuInit } from './mainMenu/mainMenu';
import { cookiesClass } from "./cookies/cookies";


import $ from "jquery";
window.jQuery = $;
window.$ = $;

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: true });
  },
};

document.addEventListener("DOMContentLoaded", DOMContentLoadedStart);
addEvent(window, "load", function () {
  afterLoadStart();
});

addEvent(window, "resize", function () {
  resize();
});

addEvent(window, "scroll", function () {
  scroll();
});

/*----- START FUNCTION -----*/
function DOMContentLoadedStart() {
  mainMenuInit();
  mobileMenuInit();
  pageScroled();
  //faqList();
  powieksz_zdjecie();
  akceptacja_ciasteczka();
  forms();
  showHideSearchForm();
  new cookiesClass();

  if (isMobile()) {
    //$("body").addClass("mobile");
  }
}

function afterLoadStart() {
  accessibilityInit();
  outlineInit();
  mainPageBanerInit();
  pageBanerInit();
  // mainPageImportantBoxesInit();
  //scrollToElementInit();
  //popUpInit();
  popUp();
  addVideoToPage();
  lazyLoadImage(document.querySelectorAll("[data-images]"));
}

function resize() {
  pageScroled();
}

function scroll() {
  pageScroled();
}

/*----- CODE BELOW -----*/
function forms() {
  let ajaxForms = $(".ajax-form");

  ajaxForms.each((idx, form) => {
    new ajaxFormClass(form);
  });
}

function mainPageBanerInit() {
  const banerTxt = document.getElementById("main-page-baner--txt");
  if (banerTxt) {
    new mainPageBaner(banerTxt);
  }
}

// function mainPageImportantBoxesInit() {
//   const banerTxt = document.getElementById("important-baner--txt");
//   if (banerTxt) {
//     new mainPageImportantBoxes(banerTxt);
//   }
// }

function pageBanerInit() {
  const elements = document.querySelectorAll(".page-baner-container");
  elements.forEach((element) => {
    new pageBaner(element);
  });
}

function mobileMenuInit() {
  window.mobileMenu = new mobileMenu();
}

function pageScroled() {
  const className = "page-scrolled";
  const showZone = document.getElementsByClassName(className);

  let scroll = $(window).scrollTop();

  if (scroll >= 10) {
    document.body.classList.add(className);
  } else {
    document.body.classList.remove(className);
  }
}

/*
function backgroundPhotoSlideInit() {
  const elements = document.querySelectorAll(".background-photo-slider");
  elements.forEach((element) => {
    new backgroundPhotoSlider(element);
  });
}
*/

function powieksz_zdjecie() {
  const tab = $("a.powieksz");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.powieksz").colorbox({
      initialWidth: 156,
      initialHeight: 80,
      maxWidth: "95%",
      maxHeight: "90%",
      scrolling: false,
      onComplete: function () {
        var $title = $(this).attr("title");
        $("body").find("img.cboxPhoto").attr("alt", $title);
      },
    });
  }
}

function showHideList() {
  let lists = $(".show-hide-list");

  lists.each((idx, list) => {
    $(list).find(".show-hide-list__hidden-element").hide();
    $(list)
      .children("li")
      .on("click", function () {
        if (!$(this).hasClass("show")) {
          $(this).addClass("show");
          $(this).find(".show-hide-list__hidden-element").slideDown();
        } else {
          $(this).removeClass("show");
          $(this).find(".show-hide-list__hidden-element").slideUp();
        }
      });
  });
}

function faqList() {
  let lists = $(".faq-list .faq-list__item");

  lists.each((idx, list) => {
    $(list).find(".faq-list__description").hide();
    $(list)
      .children(".faq-list__title")
      .on("click", function () {
        if (!$(this).parent().hasClass("show")) {
          $(this).parent().addClass("show");
          $(this).next(".faq-list__description").slideDown();
        } else {
          $(this).parent().removeClass("show");
          $(this).next(".faq-list__description").slideUp();
        }
      });
  });
}

/*----- CIASTECZKA -----*/
function akceptacja_ciasteczka() {
  $.post("/ciasteczka", { akceptacja: -1 }, function (data) {
    if (data == 1) {
      $("div.ciasteczka-info").hide();
    }
  });

  let elm = $(".akceptuje-ciasteczka");
  if (elm.length == 0) return;

  addEvent(elm[0], "click", (e) => {
    e.preventDefault();
    console.log("akceptuje-ciasteczka");
    $.post("/ciasteczka", { akceptacja: 1 });
    $("div.ciasteczka-info").fadeOut();
    return false;
  });
}
